import React from 'react';
import styles from './activity.module.css'
import {NotificationItem} from '../notification/notifcation'
const Activity =()=>{
    return(
        <div className={styles.container}>
            <h1>Activities</h1>
        <div className={styles.list}>    
        <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text="you like arham choudahry's photo"
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text='you comment on arham photo "Beatifull Click ❤️!"'
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/02-54-42-28-12-20.png"
       text='you comment on mini photo "lovely pic 😘"'
       time="3 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text=' you Liked jhondeo  photo'
       time="3 hours ago"
       mediaurl="https://vsam.me/userimages/132-03-01-21-06-14-24-3-01-21.png"

       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text='you started following jhondeo"'
       time="4 hours ago"
       />
        <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text="you liked arham choudhary photo"
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text='you comment on arham photo "Beatifull Click ❤️!"'
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text='you joined Rock_n_Roll'
       time="1 hours ago"
       mediaurl="https://image.freepik.com/free-vector/rock-n-roll-guitar_2150-167.jpg"
       />
       <NotificationItem
       ppurl="https://vsam.me/userimages/02-54-42-28-12-20.png"
       text='you comment on mini photo "lovely pic 😘"'
       time="3 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text=' you Liked jhondeo  photo'
       time="3 hours ago"
       mediaurl="https://vsam.me/userimages/132-03-01-21-06-14-24-3-01-21.png"

       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text='you started following jhondeo"'
       time="4 hours ago"
       />
        
            </div>
        </div>
    )
}


export default Activity